import React, {JSX, ReactNode, useEffect} from "react";
import {ServiceLoadingComponent} from "../components";

interface WithInstrumentProps {
    Component: React.ComponentType,
    name: string;
}

export const withInstrumentUtil = (name: string, Component: React.ComponentType, loader?: ReactNode): () => JSX.Element => {
    return function Instrument() {
        useEffect(() => {
            const start = performance.now();
            return () => {
                const dur = Math.round(performance.now() - start)
                console.info(`[service] unmount: ${name}, mounted ${dur}ms`);
            }
        }, [])

        return <React.Suspense fallback={loader || <ServiceLoadingComponent />}>
            <Component/>
        </React.Suspense>
    }
}
